import classNames from 'classnames/bind';
import React from 'react';

import styles from './NotFound.module.scss';

import ContainerFullHeight from '@/components/ui/ContainerFullHeight';

const cx = classNames.bind(styles);

const NotFound = () => {
  const reload = () => {
    window.location.replace('/');
  };

  return (
    <ContainerFullHeight className={cx('container')}>
      <div className={cx('form')}>
        <div className={cx('message')}>
          That page doesn't exist.
          <br />
          <span className={cx('accent')}>Please check the address again.</span>
          <br />
          If the problem persists, please contact the administrator.
        </div>
        <button type="button" className={cx(['button', 'accent'])} onClick={reload}>
          Reload
        </button>
      </div>
    </ContainerFullHeight>
  );
};

export default NotFound;
